<template>
  <div class="test-container" :style="`background-image: url(${publicPath}images/quiz_test-01.jpg)`">
    <div class="start" v-if="isStarted === false">
      <a class="quiz-button m-2 bg-white/90" @click="testStart">
        <span class="font-bold mb-4">Rozpocznij</span>
        Kliknij tutaj, aby rozpocząć test
      </a>
    </div>
    <div class="p-2 sm:p-16 md:p-24 w-full grid md:grid-cols-2 gap-4" v-if="completed === false && activeQuestion && isStarted">
      <div class="question-label p-8">
        <span class="text-3xl font-bold mb-4 block">Pytanie {{ activeQuestionIndex+1 }} z {{ howManyQuestions }}:</span>
        <p class="text-2xl">{{ activeQuestion.label }}</p>
      </div>
      <div class="grid gap-4">
        <a class="test-button text-xl text-left" @click="nextQuestion(answer)" v-for="(answer, index) in activeQuestion.answers" :key="index">
          {{ pointers[index] }})
          {{ answer.label }}
        </a>
      </div>

    </div>
    <div class="result-container" v-else-if="isStarted">
      <span class="mb-6 text-3xl font-bold text-center block">Koniec testu</span>
      <span class="mb-6 block text-xl">Twój wynik to:</span>
      <span style="color:#0170B9;" class="text-5xl font-bold">{{ score }}/{{ howManyQuestions }}</span>
      <a class="test-button" @click="testStart" style="margin-top: 20px;">Rozpocznij test od nowa</a>
    </div>
  </div>
</template>

<script>
import * as Helpers from './helpers'

export default {
  props: {
    questions: {
      type: Array
    },
  },
  data() {
    return {
      pointers: [
          "a", "b", "c", "d", "e"
      ],
      publicPath: process.env.BASE_URL,
      isStarted: false,
      howManyQuestions: 10,
      startTime: null,
      randomQuestions: [],
      activeQuestionIndex: 0,
      score: 0,
      completed: false,
      completeTime: null
    }
  },
  computed: {
    activeQuestion() {
      return this.randomQuestions[this.activeQuestionIndex]
    }
  },
  mounted() {
  },
  methods: {
    testStart() {
      this.startTime = Date.now()
      this.randomQuestions = JSON.parse(JSON.stringify(Helpers.getMultipleRandom(this.questions, this.howManyQuestions)))
      this.activeQuestionIndex = 0
      this.completed = false
      this.completeTime = null
      this.isStarted = true
      this.score = 0
    },
    nextQuestion(answer) {
      if ('valid' in answer && answer.valid === true) {
        this.score++;
      }
      if (this.activeQuestionIndex === this.howManyQuestions - 1) {
        this.completed = true
      } else {
        this.activeQuestionIndex++;
      }
    }
  }
}
</script>

<style>
.test-container {
  display: flex;           /* establish flex container */
  flex-direction: column;  /* make main axis vertical */
  justify-content: center; /* center items vertically, in this case */
  align-items: center;     /* center items horizontally, in this case */
  margin:0 auto;
  background-color: #F5F5F5;
  border-radius: 10px;
  max-width: 1000px;
  min-height: 650px;
  overflow: hidden;
  background-size:cover;
  background-position: center center;
}

.question-label {
  flex-basis: 100%;
  border-radius: 10px;
  background: rgba(255,255,255,0.9);
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.test-button, .quiz-button {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 10px;
  background: rgba(255,255,255,0.9);
  color:#000;
  font-size:20px;
  font-weight: bold;
  cursor:pointer;
  display:block;
  text-align:center;
  text-decoration: none !important;
}

.test-button {
  @apply text-center text-2xl font-bold p-6 hover:text-black
}

.question-container .test-button {
  text-align: left !important;
}

.test-button:hover {
  background-color:#fff;
  color:#000;
}

.result-container {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  background: rgba(255,255,255,0.9);
  color:#000;
  padding:25px;
  border-radius: 10px;
  text-align: center;
}
</style>